import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEng from "./Locales/en/translation.json";
import translationGer from "./Locales/ger/translation.json";
import translationFin from "./Locales/fi/translation.json";
import translationEsp from "./Locales/es/translation.json";
import translationFra from "./Locales/fr/translation.json";



i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        lng: "en",    // let use language detector
        fallbackLng: "en", // use en if detected lng is not available

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        },
        whitelist: [
            'en', 'fi', 'es',     //  'fr', 'de',
        ],
        resources: {
            en: {
                translations: translationEng
            },
            de: {
                translations: translationGer
            },
            fi: {
                translations: translationFin
            },
            es: {
                translations: translationEsp
            },
            fr: {
                translations: translationFra
            }
        },
        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations"
    });

export default i18n;

/*
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEng from "./Locales/en/translation.json";
import translationGer from "./Locales/ger/translation.json";
import translationFin from "./Locales/fi/translation.json";
import translationEsp from "./Locales/es/translation.json";
import translationFre from "./Locales/fr/translation.json";

i18n
    .use(XHR)
    .use(LanguageDetector)
    .init({
        debug: true,
        lng: "en",
        fallbackLng: "en", // use en if detected lng is not available

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        },

        resources: {
            en: {
                translations: translationEng
            },
            ger: {
                translations: translationGer
            },
            fi: {
                translations: translationFin
            },
            es: {
                translations: translationEsp
            },
            fr: {
                translations: translationFre
            }
        },
        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations"
    });

export default i18n;


*/